// One icon per expense category, so a long list scans at a glance.
export const CATEGORY_ICON = {
  Bus: "🚌",
  "Simulator & tech": "🖥️",
  "Golf gear": "🏌️",
  "Event setup": "🎪",
  "Merch & giveaways": "🧢",
  "Marketing & branding": "📣",
  "Website & software": "🌐",
  "Legal & admin": "📄",
  Insurance: "🛡️",
  "Fuel & travel": "⛽",
  "Maintenance & repairs": "🔧",
  "Fees & interest": "🏦",
  Other: "📦",
};

export const categoryIcon = (c) => CATEGORY_ICON[c] || "📦";
